<p-tag [icon]="icon" [style]="tagStyles" [value]="value" [rounded]="true" [ngStyle]="iconStyle"></p-tag>
